import {SetGetBet} from './thunk/setGetBet';
import {SetGetDailyList} from './thunk/setGetDailyList';
import {SetGetGamerInformation} from './thunk/setGetGamerInformation';
import {SetGetShift} from './thunk/setGetShift';
import {SetGetGroups} from './thunk/setGetGroups';
import {SetGetOperatorDetalization} from './thunk/setGetOperatorDetalization';
import {SetViewGroups} from './thunk/setGetViewGroup';
import {SetPostUpdateBalance} from './thunk/setPostUpdateBalance';

export const Thunks = {
    SetGetBet,
    SetGetDailyList,
    SetGetGamerInformation,
    SetGetGroups,
    SetGetOperatorDetalization,
    SetGetShift,
    SetViewGroups,
    SetPostUpdateBalance
}